<template>
	<div class="ai-diagnosis">
		<h3 class="diagnosis-title">
			AI诊断
			<el-tag size="mini" :type="statusType">{{ statusText }}</el-tag>
		</h3>
		<div v-if="notRequired" class="not-required">规则诊断已确认链路完整，无需 AI 辅助诊断</div>
		<div v-else-if="unavailable" class="unavailable">本次 AI 诊断暂不可用，请稍后重试</div>
		<div v-else class="content">
			<div class="item full">
				<span>诊断结论</span>
				<p>{{ summary }}</p>
			</div>
			<div v-if="result && result.cause" class="item full">
				<span>直接原因</span>
				<p>{{ result.cause }}</p>
			</div>
			<div v-if="actions.length" class="item full">
				<span>建议处理</span>
				<ol>
					<li v-for="item in actions" :key="item">{{ item }}</li>
				</ol>
			</div>
			<div v-if="result && result.limitation" class="item full">
				<span>分析限制</span>
				<p>{{ result.limitation }}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		result: { type: Object, default: null },
		running: Boolean,
		notRequired: Boolean,
	},
	computed: {
		unavailable() {
			return !this.notRequired && this.result && this.result.status === 'UNAVAILABLE'
		},
		statusText() {
			if (this.notRequired) return '无需 AI 诊断'
			if (!this.result) return this.running ? '分析中' : '等待结果'
			if (this.unavailable) return '诊断不可用'
			return (
				{
					COMPLETE: '链路完整',
					INCOMPLETE: '链路异常',
					UNCERTAIN: '证据不足',
				}[this.result.communicationStatus] || '分析完成'
			)
		},
		statusType() {
			if (this.notRequired) return 'success'
			if (this.unavailable || (this.result && this.result.communicationStatus === 'INCOMPLETE')) return 'danger'
			if (this.result && this.result.communicationStatus === 'COMPLETE') return 'success'
			return 'info'
		},
		summary() {
			return (this.result && this.result.summary) || (this.running ? '正在生成 AI 诊断结论...' : '--')
		},
		actions() {
			return (this.result && this.result.recommendedActions) || []
		},
	},
}
</script>

<style lang="scss" scoped>
.ai-diagnosis {
	padding: 20px 0;
	.diagnosis-title {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		.el-tag {
			margin-left: 8px;
		}
	}
	.content,
	.not-required,
	.unavailable {
		margin-top: 16px;
		padding: 16px 20px;
		border-radius: 4px;
		background: #f0f3fc;
		color: #5f667d;
	}
	.item + .item {
		margin-top: 14px;
	}
	.item span {
		display: block;
		margin-bottom: 6px;
		color: #333;
		font-weight: 600;
	}
	.item p,
	.item li {
		line-height: 22px;
	}
	.item ol {
		padding-left: 20px;
	}
}
</style>
